/* hb-quicksearch.js - card-aware quick-add search drawer.
   Shopify's predictive endpoint returns no variant ids, so variants are
   resolved per result from /products/<handle>.js before add-to-cart. */
(function(){
  var D = null, INPUT=null, LIST=null, TALLY=null, MSG=null;
  var cache = {}, results = [], added = [], timer=null, reqId=0;

  function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':String(s); return d.innerHTML; }
  function money(c){ return '$' + (c/100).toFixed(2); }
  function cleanName(t){
    var n = String(t||'').split(' [')[0].trim();
    var p = n.split(' (');
    if(p.length>1) n = p[0].trim();
    return n;
  }
  function setCode(t){ var m=String(t||'').match(/\[([^\]]+)\]\s*$/); return m? m[1] : ''; }

  function build(){
    D = document.createElement('div');
    D.className='hbqs'; D.hidden=true;
    D.innerHTML =
      '<div class="hbqs__scrim"></div>'+
      '<aside class="hbqs__panel" role="dialog" aria-label="Quick add cards">'+
        '<header class="hbqs__head">'+
          '<div><h2>Quick add</h2><p>Search and add as many cards as you like without leaving the page.</p></div>'+
          '<button class="hbqs__x" aria-label="Close">&times;</button>'+
        '</header>'+
        '<div class="hbqs__searchwrap">'+
          '<input class="hbqs__input" type="search" placeholder="Search cards, sets, numbers…" autocomplete="off" aria-label="Search cards">'+
        '</div>'+
        '<div class="hbqs__results"></div>'+
        '<footer class="hbqs__foot">'+
          '<div class="hbqs__tally"></div>'+
          '<div class="hbqs__msg"></div>'+
          '<a class="hbqs__cart button" href="/cart">View cart</a>'+
        '</footer>'+
      '</aside>';
    document.body.appendChild(D);
    INPUT=D.querySelector('.hbqs__input'); LIST=D.querySelector('.hbqs__results');
    TALLY=D.querySelector('.hbqs__tally'); MSG=D.querySelector('.hbqs__msg');
    wire();
  }

  function open(){
    if(!D) build();
    D.hidden=false; document.body.style.overflow='hidden';
    setTimeout(function(){ INPUT.focus(); }, 60);
    if(!results.length) hint();
    renderTally();
  }
  function close(){ if(D){ D.hidden=true; document.body.style.overflow=''; } }

  function hint(){
    LIST.innerHTML = '<p class="hbqs__hint">Start typing a card name. Every printing we stock shows up with its set, finish and price — add straight from here.</p>';
  }

  async function variantsFor(handle){
    if(cache[handle]) return cache[handle];
    try{
      var r = await fetch('/products/'+handle+'.js');
      if(!r.ok){ cache[handle]=[]; return []; }
      var p = await r.json();
      cache[handle] = (p.variants||[]).filter(function(v){ return v.available; });
      return cache[handle];
    }catch(e){ cache[handle]=[]; return []; }
  }

  function row(p, i){
    var vs = cache[p.handle];
    var name = cleanName(p.title), code = setCode(p.title);
    var opts='';
    if(vs && vs.length>1){
      opts = '<select class="hbqs__var" data-i="'+i+'" aria-label="Choose condition">'
        + vs.map(function(v,vi){ return '<option value="'+v.id+'">'+esc(v.title)+' — '+money(v.price)+'</option>'; }).join('')
        + '</select>';
    } else if(vs && vs.length===1){
      opts = '<span class="hbqs__one">'+esc(vs[0].title)+'</span>';
    }
    var imgSrc = (p.featured_image && p.featured_image.url) || (typeof p.image==='string'? p.image : '') || '';
    var price = (vs && vs.length)? money(vs[0].price) : '';
    var dis = (vs && vs.length)? '' : ' disabled';
    return '<div class="hbqs__row" data-i="'+i+'">'
      + '<span class="hbqs__thumb">'+(imgSrc? '<img loading="lazy" alt="" src="'+imgSrc+'">':'')+'</span>'
      + '<span class="hbqs__meta">'
      +   '<span class="hbqs__name">'+esc(name)+'</span>'
      +   '<span class="hbqs__sub">'+(code? '<span class="hbqs__set">'+esc(code)+'</span>':'')+'<span class="hbqs__price">'+price+'</span></span>'
      +   (opts? '<span class="hbqs__opts">'+opts+'</span>' : '<span class="hbqs__opts hbqs__opts--none">out of stock</span>')
      + '</span>'
      + '<button class="hbqs__add"'+dis+' data-i="'+i+'" aria-label="Add '+esc(name)+'">+</button>'
      + '</div>';
  }

  async function search(q){
    var mine = ++reqId;
    if(!q || q.trim().length<2){ hint(); results=[]; return; }
    LIST.innerHTML='<p class="hbqs__hint">Searching…</p>';
    var qs = String.fromCharCode(63)+'q='+encodeURIComponent(q)
      +'&resources'+String.fromCharCode(91)+'type'+String.fromCharCode(93)+'=product'
      +'&resources'+String.fromCharCode(91)+'limit'+String.fromCharCode(93)+'=10';
    var ps=[];
    try{ var j = await (await fetch('/search/suggest.json'+qs)).json(); ps = (j.resources.results.products)||[]; }
    catch(e){ if(mine===reqId) LIST.innerHTML='<p class="hbqs__hint">Search is unavailable right now.</p>'; return; }
    if(mine!==reqId) return;
    if(!ps.length){ LIST.innerHTML='<p class="hbqs__hint">Nothing matched “'+esc(q)+'”. Try a shorter name or a set code.</p>'; results=[]; return; }
    results = ps;
    LIST.innerHTML = ps.map(row).join('');
    for(var i=0;i<ps.length;i+=5){
      await Promise.all(ps.slice(i,i+5).map(function(p){ return variantsFor(p.handle); }));
      if(mine!==reqId) return;
      LIST.innerHTML = results.map(row).join('');
    }
  }

  async function add(i){
    var p = results[i]; if(!p) return;
    var vs = cache[p.handle]||[];
    if(!vs.length) return;
    var sel = LIST.querySelector('.hbqs__var[data-i="'+i+'"]');
    var vid = sel ? Number(sel.value) : vs[0].id;
    var chosen = vs.filter(function(v){ return v.id===vid; })[0] || vs[0];
    var btn = LIST.querySelector('.hbqs__add[data-i="'+i+'"]');
    if(btn){ btn.disabled=true; btn.textContent='…'; }
    try{
      var r = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:vid, quantity:1}]})});
      if(!r.ok) throw new Error('cart');
      added.push({ name:cleanName(p.title), set:setCode(p.title), variant:chosen.title, price:chosen.price });
      renderTally();
      MSG.textContent = 'Added ' + cleanName(p.title);
      if(btn){ btn.textContent='✓'; setTimeout(function(){ btn.textContent='+'; btn.disabled=false; }, 900); }
      document.dispatchEvent(new CustomEvent('hb:cart-updated'));
    }catch(e){
      MSG.textContent='Could not add that one.';
      if(btn){ btn.textContent='+'; btn.disabled=false; }
    }
  }

  function renderTally(){
    if(!added.length){ TALLY.innerHTML='<span class="hbqs__empty">Nothing added yet</span>'; return; }
    var total = added.reduce(function(a,b){ return a+b.price; },0);
    TALLY.innerHTML = '<b>'+added.length+'</b> card'+(added.length===1?'':'s')+' added · <b>'+money(total)+'</b>';
  }

  function wire(){
    D.querySelector('.hbqs__x').addEventListener('click', close);
    D.querySelector('.hbqs__scrim').addEventListener('click', close);
    D.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    INPUT.addEventListener('input', function(e){
      clearTimeout(timer); var v=e.target.value;
      timer=setTimeout(function(){ search(v); }, 220);
    });
    INPUT.addEventListener('keydown', function(e){
      if(e.key==='Enter'){ e.preventDefault(); var f=LIST.querySelector('.hbqs__add:not([disabled])'); if(f) add(Number(f.getAttribute('data-i'))); }
    });
    LIST.addEventListener('click', function(e){
      var b=e.target.closest('.hbqs__add'); if(b && !b.disabled) add(Number(b.getAttribute('data-i')));
    });
  }

  function bind(){
    var sum = document.querySelector('details-modal.header__search summary');
    if(!sum || sum.dataset.hbqs) return;
    sum.dataset.hbqs='1';
    sum.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var det = sum.closest('details'); if(det) det.open=false;
      open();
    }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  new MutationObserver(function(){ bind(); }).observe(document.documentElement,{childList:true,subtree:true});
  window.HBQuickSearch = { open:open, close:close };
})();
